import { useSmoothedText } from "@sill/shared/chat/useSmoothedText";

import { ProMarkdown } from "./ProMarkdown";

// Token-level streaming smoothing (SILL-459) for the copilot assistant bubble.
// A dedicated component so `useSmoothedText` is called at a component top level
// (never inside the `messages.map` in ChatDockPanel — rules of hooks). Non-
// streaming / finished messages reveal instantly; reduced-motion is instant.
export function CopilotAssistantText({
  text,
  streaming,
}: {
  text: string;
  streaming: boolean;
}) {
  const smoothed = useSmoothedText(text, { streaming });
  return <ProMarkdown>{smoothed}</ProMarkdown>;
}
